import {
  faFileImport,
  faListCheck,
  faStamp,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { useLocation } from "react-router-dom";

import { SubscriptionForm } from "../components/SubscriptionForm";

const content: Record<
  string,
  {
    kicker: string;
    title: string;
    body: string;
    features?: Array<{
      heading: string;
      body: string;
      icon: typeof faFileImport;
    }>;
  }
> = {
  "/features": {
    kicker: "Features",
    title: "From source agenda to published guide.",
    body: "Import. Review. Adopt. Publish.",
    features: [
      {
        heading: "Import the agenda",
        body: "Paste rows, upload a CSV, or extract items from a PDF. Source pages stay attached.",
        icon: faFileImport,
      },
      {
        heading: "Review side by side",
        body: "Set personal and organization positions without leaving the agenda.",
        icon: faListCheck,
      },
      {
        heading: "Publish with confidence",
        body: "Create versioned web, print, and PDF guides from one record.",
        icon: faStamp,
      },
    ],
  },
  "/pricing": {
    kicker: "Pricing",
    title: "Private beta access.",
    body: "Paid plans are not offered during beta.",
  },
  "/blog": {
    kicker: "Product notes",
    title: "Updates, when they matter.",
    body: "Release notes and product guidance will appear here.",
  },
};

export function MarketingPage() {
  const { pathname } = useLocation();
  const page = content[pathname] ?? content["/features"]!;
  return (
    <div className="page-section marketing-page">
      <div className="container marketing-container">
        <header className="marketing-header">
          <p className="kicker">{page.kicker}</p>
          <h1>{page.title}</h1>
          <p className="lead">{page.body}</p>
        </header>
        {page.features ? (
          <div className="marketing-feature-grid">
            {page.features.map((feature) => (
              <article key={feature.heading}>
                <FontAwesomeIcon icon={feature.icon} aria-hidden="true" />
                <h2>{feature.heading}</h2>
                <p>{feature.body}</p>
              </article>
            ))}
          </div>
        ) : null}
        <div className="beta-callout">
          <div>
            <p className="kicker">Updates</p>
            <h2>Know when access expands.</h2>
          </div>
          <SubscriptionForm idPrefix={`${pathname.slice(1)}-updates`} />
        </div>
      </div>
    </div>
  );
}
